import { track } from "@amplitude/analytics-browser";
import { Modal } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link, Outlet, useParams } from "react-router-dom";
import SearchFail from "src/assets/images/SearchFail/searchFail.png";
import { RootState } from "src/store";

export default function FlightsWrapper() {
  const { t } = useTranslation();
  const isExpired = useSelector((state: RootState) => state.timer.isExpired);
  const { searchId } = useParams();
  const [isOpen, setIsOpen] = useState(isExpired && !!searchId);
  const handleClick = () => {
    setIsOpen(false);
  };
  const handleGoHome = () => {
    handleClick();
    track("Session Expired", {
      behaviourAfter: "Went Home",
    });
  };
  const handleSearchAgain = () => {
    handleClick();
    track("Session Expired", {
      behaviourAfter: "Searched Again",
    });
  };
  useEffect(() => {
    if (isExpired && searchId) {
      setIsOpen(true);
    }
  }, [isExpired]);
  return (
    <div>
      <Outlet />
      <Modal
        open={isOpen}
        onCancel={() => setIsOpen(false)}
        footer={null}
        closeIcon={null}
        className="w-120! h-120! aspect-square!"
        closable={false}
        mask={{
          closable: false,
        }}
        classNames={{
          container:"p-4!"
        }}
      >
        <div className="p-3! flex flex-col items-center gap-3">
          <div className="w-30 h-30">
            <img src={SearchFail} alt="" className="h-full w-full object-contain" />
          </div>
          <div className="text-2xl font-bold">{t("Flights.common.sessionExpired")}</div>
          <div className="text-font-subtle text-center font-semibold">{t("Flights.common.refreshToSeeLatest")}</div>
          <div className="flex w-full gap-4">
            <Link
              to="/travel"
              onClick={handleGoHome}
              className="bg-background-subtle! text-font-active! flex flex-1 items-center justify-center rounded-md p-4 text-center"
            >
              {t("Flights.common.goHome")}
            </Link>
            <Link
              to={`/travel/tickets/${searchId}?t=${Date.now()}`}
              onClick={handleSearchAgain}
              className="text-font-inverted! bg-background-primary! flex flex-1 items-center justify-center rounded-md p-4 text-center"
            >
              {t("Flights.common.refreshSearch")}
            </Link>
          </div>
        </div>
      </Modal>
    </div>
  );
}
